import { render, staticRenderFns } from "./NotificationTemplateTreatmentDirectionsOfUse.vue?vue&type=template&id=ba022cda&scoped=true"
import script from "./NotificationTemplateTreatmentDirectionsOfUse.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateTreatmentDirectionsOfUse.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateTreatmentDirectionsOfUse.vue?vue&type=style&index=0&id=ba022cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba022cda",
  null
  
)

export default component.exports